import React, { useEffect, useState } from "react";
import { useNavigate, NavLink, useLocation } from "react-router-dom";
import Footer from "../../../components/Footer";
import { PiUserCircleThin } from "react-icons/pi";
import Cookies from "js-cookie";
import "./Navigation.css";
import Header from "./Header";
import CTCBI from "../../../assets/images/CertifiedTrueCopy-BI.png";
import SuggestionBoxImage from "../../../assets/images/suggestion-box.png";
import SupportIcon from "../../../assets/images/assistance.png";
import SuggestionBox from "../suggestionBox/SuggestionBox";
import SampleCtc from "../sampleCtc/SampleCtc";
import api from "../../../services/baseUrl";

export default function WartaNavigation({ children }) {
  const navigate = useNavigate();
  const cookie =
    Cookies.get("wartaUser");
  const user = JSON.parse(cookie);
  const userRole = user.isAdmin;
  const userId = user.userId;
  const [activeMenu, setActiveMenu] = useState("GAZETTE FINDER");
  const [openFeedbackDialog, setOpenFeedbackDialog] = useState(false);
  const [openCtcDialog, setOpenCtcDialog] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const handleLogout = () => {
    Cookies.remove("wartaUser", { secure: true, sameSite: "Strict" });
    sessionStorage.removeItem("wartaUser");
    navigate("/eWarta/login");
  };
  const location = useLocation();

  const userMenuItem = [
    {
      path: "/eWarta/gazetteFinder",
      name: "GAZETTE FINDER",
    },
    {
      name: "YOUR HISTORY",
      submenu: [
        { path: "/eWarta/searchHistory", name: "SEARCH HISTORY" },
        // { path: "/eWarta/frequentHistory", name: "FREQUENT HISTORY" },
        { path: "/eWarta/purchaseHistory", name: "PURCHASE HISTORY" },
      ],
    },
  ];

  const adminMenuItem = [
    {
      path: "/eWarta/requests",
      name: "REQUEST LIST",
    },
  ];

  const handleClick = (subItem) => {
    setActiveMenu(subItem.name);
  };

  useEffect(() => {
    const fetchUnreadCount = async () => {
      const response = await api.get("/notification/unread-count", {
        params: { userId },
      });
      setUnreadCount(response.data);
    };
    if (userId) {
      fetchUnreadCount();
    }
  }, [userId, location.pathname]);

  // Determine which menu to use based on user role
  const menuItems = userRole ? adminMenuItem : userMenuItem;

  return (
    <div>
      <Header handleLogout={handleLogout} />
      <div className="drawer-container">
        <div className={"drawer-open"}>
          <div className="drawer-content">
            <div className="drawer-profile">
              <PiUserCircleThin className="drawer-profile-icon" />
              <div className="drawer-profile-text">
                <p className="drawer-welcome">Welcome</p>
                <p className="drawer-name">{user?.fullName.toUpperCase()}</p>
                <p
                  className="drawer-inbox"
                  style={{
                    cursor: "pointer",
                    fontWeight: unreadCount > 0 ? "bold" : "normal",
                  }}
                  onClick={() => {
                    setActiveMenu(null);
                    navigate("/eWarta/inbox");
                  }}
                >
                  Inbox ({unreadCount})
                </p>
              </div>
            </div>

            {menuItems.map((item, index) => (
              <div key={index}>
                {item.submenu ? (
                  <div className={`drawer-with-submenu warta-menu`}>
                    <div className="drawer-with-submenu-text">{item.name}</div>
                  </div>
                ) : (
                  <NavLink
                    to={item.path}
                    className={`warta-menu ${
                      activeMenu === item.name
                        ? "warta-menu-active"
                        : "drawer-menu-inactive"
                    }`}
                    onClick={(e) => {
                      if (item.path === null) {
                        e.preventDefault();
                      }
                      handleClick(item);
                    }}
                  >
                    <div className="drawer-menu-text">{item.name}</div>
                  </NavLink>
                )}
                {item.submenu && (
                  <div className="drawer-submenu">
                    {item.submenu.map((subItem, subIndex) => {
                      const isActive = activeMenu === subItem.name;
                      return (
                        <NavLink
                          to={subItem.path || "#"}
                          key={subIndex}
                          className={
                            isActive
                              ? "drawer-submenu-active"
                              : "drawer-submenu-inactive"
                          }
                          onClick={(e) => {
                            if (subItem.path === null) {
                              e.preventDefault();
                            }
                            handleClick(subItem);
                          }}
                        >
                          <div className="drawer-submenu-text">
                            {subItem.name}
                          </div>
                        </NavLink>
                      );
                    })}
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="warta-navigation-button-container">
            <button
              className="warta-navigation-button"
              onClick={() => {
                setOpenFeedbackDialog(true);
              }}
            >
              <p style={{ marginLeft: "auto" }}>
                Suggestion <br /> Box
              </p>
              <img
                src={SuggestionBoxImage}
                alt=""
                className="warta-navigation-button-icon"
              />
            </button>
            <button
              className="warta-navigation-button"
              onClick={() => {
                setOpenCtcDialog(true);
              }}
            >
              Sample Gazette with Certified True Copy
              <img
                src={CTCBI}
                alt=""
                className="warta-navigation-button-icon"
              />
            </button>
            <button className="warta-navigation-button">
              Need Assistance? Call our team now <br /> 03-92366085
              <img
                src={SupportIcon}
                alt=""
                className="warta-navigation-button-icon"
              />
            </button>
          </div>
        </div>
        <main className="drawer-page-content">{children}</main>
      </div>
      <Footer openDialog={openDialog} setOpenDialog={setOpenDialog} />

      <SuggestionBox
        openFeedbackDialog={openFeedbackDialog}
        setOpenFeedbackDialog={setOpenFeedbackDialog}
      />
      <SampleCtc
        openCtcDialog={openCtcDialog}
        setOpenCtcDialog={setOpenCtcDialog}
      />
    </div>
  );
}
